import {UserModuleDb} from '@cp/model';
import {useCallback} from 'react';
import getUserDoc from '../../api/user/getUserDoc';
import updateUserDoc from '../../api/user/updateUserDoc';
import {getCurrentUserIdValidated} from '../../config/firebaseUser';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useRemoveSelectedModules() {
  const removeSelectedModulesFn = useCallback(async (moduleId: string): Promise<void> => {
    const uid = await getCurrentUserIdValidated();
    const user = await getUserDoc(uid);
    const current: UserModuleDb[] = (user?.selectedModules ?? []).map((m) => ({moduleId: m.moduleId}));
    const next = current.filter((m) => m.moduleId !== moduleId);
    await updateUserDoc(uid, {selectedModules: next});
  }, []);

  const {loading, error, refetch} = useFunctionRun(removeSelectedModulesFn, {
    skipLoadOnMount: true,
  });

  return {
    removeSelectedModules: refetch,
    loading,
    error,
  };
}
